import { type RequestedResponder } from '@atlassian/eoc-schedule-common';

import {
	type DayTimeRange,
	type OptionField,
	type RotationType,
	type ShiftFrequency,
	type TimingType,
} from '../../common/types';

/**
 * Original values before hack for shifted responders is applied
 */
export type OriginalBeforeRecipientUpdate = {
	participants?: RequestedResponder<true, true>[];
	startTime?: string;
};

export type TemplateOption = {
	value: string;
	label: string;
	restrictions: DayTimeRange[];
	timingType?: TimingType;
};

/**
 * Shifted participants hack status
 */
export enum HackStatus {
	/** @description No hack is applied or rejected. Participants havent been modified */
	None = 1,
	/** @description Hack is applied. But can be rejected if requested. */
	Applied,
	/** @description Hack was applied. Now rejected, which the terminal state. */
	Rejected,
}

export type FormFields = {
	name: string;
	restrictions: DayTimeRange[];
	participants: RequestedResponder<true, true>[];
	shiftFrequency: OptionField<ShiftFrequency>;
	shiftPeriod: string;
	shiftType: OptionField<RotationType>;
	startTime: string;
	hasEndTime: boolean;
	endTime?: string | null;
	template?: TemplateOption | null;
	timingType?: TimingType | null;
	hackStatus: HackStatus;
};
